import { connect } from "react-redux";

import { actions as appActions } from "./App.redux";
import { actions as loginActions } from "../login";

import App from "./App.view";
import withAnalytics from "../analytics";
import withUpdates from "../updates";

const mapStateToProps = state => ({
  authenticated: !!state.login.auth.expires,
  dataLayerListingParameters: state.analytics.dataLayerListingParameters,
  dataLayerSearchParameters: state.analytics.dataLayerSearchParameters,
  targetDevice: state.targetDevice,
  userId: !!state.login.user && state.login.user.id,
  userRole: !!state.login.user && state.login.user.role,
});

const mapDispatchToProps = dispatch => ({
  checkAuth: () => dispatch(loginActions.check()),
  checkFeatureSupport: () => dispatch(appActions.checkFeatureSupport()),
  routeChange: () => dispatch(appActions.routeChange()),
  updateTargetDevice: device => dispatch(appActions.updateTargetDevice(device)),
});

export default withUpdates(
  connect(mapStateToProps, mapDispatchToProps)(withAnalytics(App))
);
